//配置路由的地方
import Vue from 'vue';
import VueRouter from 'vue-router';


// 重写路由的push方法
 
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

//使用插件
Vue.use(VueRouter);
//引入路由组件
import Home from '@/pages/Home/Home.vue'
// import hangYeAnLi from '@/pages/hangYeAnLi/hangYeAnLi.vue'
import callMe from '@/pages/callMe/callMe.vue'
import chanPinNengLi from '@/pages/chanPinNengLi/chanPinNengLi.vue'
import yinsi from "@/pages/yinsi/yinsi";
import fuwuxieyi from "@/pages/fuwuxieyi/fuwuxieyi";

//配置路由
export default new VueRouter({
    routes:[
        {
            path:'/home',
            component:Home
        },
        {
            path:'/callMe',
            component:callMe
        },
        {
            path:'/chanPinNengLi',
            component:chanPinNengLi
        },
        {
            path:'/yinsi',
            component:yinsi
        },
        {
            path:'/fuwuxieyi',
            component:fuwuxieyi
        },
        //重定向
        {
            path:'*',
            redirect:'/home'
        }
    ]
})